import { deleted } from "../actions";
import { url } from "../../../url";

const deleteTodo = (todoId) => {
    return async (dispatch) => {
        await fetch(`${url}/${todoId}`, {
            method: "DELETE",
        });
        dispatch(deleted(todoId));
    }
};

export default deleteTodo;